<template>
    <li>
        <a href="#" title="Switch user" @click="openModal">
            <i class="fa fa-user-friends fa-fw"></i> Switch user
        </a>
    </li>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openModal() {
      // Grab the modal
      var modal = document.getElementById("switchUserModal");
      // open it
      $(modal).foundation("reveal", "open");
    }
  },
  computed: {},
  components: {}
};
</script>

<style>
</style>